<template>
<div class="chapter">
<div class="inner_page">
<div><a id="page_i"></a><a id="Cover">
<p style="margin-top:0px; margin-left:0px; margin-right:0px; margin-bottom:0px; text-align:center; background-color:#00007;"><img alt="Inside the Box: How CrossFit ® Shredded the Rules, Stripped Down the Gym, and Rebuilt My Body, by T.J. Murphy." src="images/cover.jpg" style="height:100%; text-align:center;"/></p>
</a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?6fa67d6f